import { numberToString } from './numeric';
import { rad2deg } from '../utils/math';
import { isFinite, isNil } from '@antv/util';
import { AABB } from '../shapes';
import { computeInheritStyleProperty } from './inherit';

function isLengthUnit(unit) {
  return unit === 'px' || unit === '%' || unit === 'em';
}

function isAngleUnit(unit) {
  return unit === 'deg' || unit === 'rad' || unit === 'turn';
}

export function parseDimension(unitRegExp, string, object, name) {
  string = "".concat(string).trim().toLowerCase();

  if (string === 'inherit') {
    var computed = computeInheritStyleProperty(object, name);

    if (!isNil(computed)) {
      return computed;
    }
  }

  if (string === '0') {
    if ('px'.search(unitRegExp) >= 0) {
      // 0 -> 0px
      return {
        unit: 'px',
        value: 0
      };
    } else if ('%'.search(unitRegExp) >= 0) {
      // 0 -> 0%
      return {
        unit: '%',
        value: 0
      };
    }
  } else if (string === 'auto' || string === 'inherit') {
    return {
      unit: '',
      value: 0
    };
  }

  if (isFinite(Number(string))) {
    if ('px'.search(unitRegExp) >= 0) {
      return {
        unit: 'px',
        value: Number(string)
      };
    } else {
      return {
        unit: '',
        value: Number(string)
      };
    }
  }

  if (string.endsWith('em')) {
    var pxValue = 0;

    if (object.parentElement) {
      var fontSize = object.parentElement.parsedStyle.fontSize;

      if (fontSize && fontSize.value) {
        pxValue = fontSize.value * Number(string.replace('em', ''));
      }
    }

    return {
      unit: 'px',
      value: pxValue
    };
  }

  var matchedUnits = [];
  string = string.replace(unitRegExp, function (match) {
    matchedUnits.push(match);
    return 'U' + match;
  });
  var taggedUnitRegExp = 'U(' + unitRegExp.source + ')';
  return matchedUnits.map(function (unit) {
    return {
      unit: unit,
      value: Number(string.replace(new RegExp('U' + unit, 'g'), '').replace(new RegExp(taggedUnitRegExp, 'g'), '*0'))
    };
  })[0];
}
/**
 * eg. 10px + 20px = 30px
 */

export function mergeDimensions(left, right, nonNegative, target, index) {
  if (target === void 0) {
    target = null;
  }

  if (index === void 0) {
    index = 0;
  }

  var unit = left.unit;
  var leftValue = left.value || 0;
  var rightValue = right.value || 0; // format '%' to 'px'

  if (isLengthUnit(left.unit) || isLengthUnit(right.unit)) {
    leftValue = convertPercentUnit(left, index, target);
    rightValue = convertPercentUnit(right, index, target);
    unit = 'px';
  } // format 'rad' 'turn' to 'deg'


  if (isAngleUnit(left.unit) || isAngleUnit(right.unit)) {
    leftValue = convertAngleUnit(left);
    rightValue = convertAngleUnit(right);
    unit = 'deg';
  }

  return [leftValue, rightValue, function (value) {
    if (nonNegative) {
      value = Math.max(value, 0);
    }

    return numberToString(value) + unit;
  }];
}
var lengthUnits = 'px';
/**
 * length with only absolute unit, eg. 1px
 */

export var parseLength = parseDimension.bind(null, new RegExp(lengthUnits, 'g'));
/**
 * length with absolute or relative unit, eg. 1px, 0.7em, 50%
 */

export var parseLengthOrPercent = parseDimension.bind(null, new RegExp(lengthUnits + '|%|em', 'g'));
export var parseAngle = parseDimension.bind(null, /deg|rad|grad|turn/g);
export function parseLengthOrPercentList(list) {
  return list.map(parseLengthOrPercent);
} // export function mergeDimensionsLists(
//   left: ParsedElement[],
//   right: ParsedElement[],
//   target: DisplayObject | null,
// ): [ParsedElement[], ParsedElement[], (list: ParsedElement[]) => string] | undefined {
//   if (left.length != right.length) {
//     return;
//   }
//   return [
//     leftValue,
//     rightValue,
//     (value: number) => {
//       if (nonNegative) {
//         value = Math.max(value, 0);
//       }
//       return numberToString(value) + unit;
//     },
//   ];
// }

export function convertPercentUnit(valueWithUnit, vec3Index, target) {
  if (valueWithUnit.unit === 'px') {
    return Number(valueWithUnit.value);
  } else if (valueWithUnit.unit === '%' && target) {
    // use bounds
    var bounds = target.getBounds();
    var size = 0;

    if (!AABB.isEmpty(bounds)) {
      size = bounds.halfExtents[vec3Index] * 2;
    }

    return Number(valueWithUnit.value) / 100 * size;
  }

  return 0;
}
export function convertAngleUnit(valueWithUnit) {
  var deg = 0;

  if (valueWithUnit.unit === 'deg') {
    deg = Number(valueWithUnit.value);
  } else if (valueWithUnit.unit === 'rad') {
    deg = rad2deg(Number(valueWithUnit.value));
  } else if (valueWithUnit.unit === 'turn') {
    deg = 360 * Number(valueWithUnit.value);
  }

  return deg;
}